import { inject, Injectable } from '@angular/core';
import { Market } from '@vueling-ng/vy-cdk-searcher';
import { map, Observable } from 'rxjs';
import { MarketByOrigin } from './models/resources.interface';
import { ResourcesService } from './resources-service';

@Injectable({ providedIn: 'root' })
export class ResourcesDataService {
  private readonly resourcesService = inject(ResourcesService);

  public getMarkets(originCode: string): Observable<Market[]> {
    return this.resourcesService
      .marketsByOriginStation(originCode)
      .pipe(map((markets: MarketByOrigin[]) => this.mapMarketResponse(markets)));
  }

  private mapMarketResponse(response: MarketByOrigin[]): Market[] {
    return response.map(
      (market: MarketByOrigin) =>
        ({
          fromCode: market.fromCode,
          toCode: market.toCode
        }) as Market
    );
  }
}
